import {
  ProductSyncFilters,
  initialProductSyncFilters
} from "../models/Filters";

const storage: Storage = window.localStorage;

const FILTERS = "product_sync.filters";

export const Storage = {
  get filters(): ProductSyncFilters {
    let val = storage.getItem(FILTERS);
    return val
      ? (JSON.parse(val) as ProductSyncFilters)
      : initialProductSyncFilters;
  },

  set filters(value: ProductSyncFilters) {
    storage.setItem(FILTERS, JSON.stringify(value));
  }
};
